import React, { useEffect, useState } from 'react';
import { useConfigurator } from '../../context/ConfiguratorContext';
import translationInstance from '../../utils/translations';
import './LanguageSelector.scss';

// Check if multilanguage support is enabled
const isMultilangEnabled = process.env.REACT_APP_MULTILANG === '1';

const LanguageSelector: React.FC = () => {
  const { selectedLanguage, setSelectedLanguage } = useConfigurator();
  const [mounted, setMounted] = useState(false);
  
  // Set English as the default language
  useEffect(() => {
    setMounted(true);
    // Always use English as the default language
    setSelectedLanguage('en');
    translationInstance.setLanguage('en');
    
    // Force UI update
    window.dispatchEvent(new Event('languageChanged'));
  }, [setSelectedLanguage]);
  
  const handleLanguageChange = (newLanguage: string) => {
    setSelectedLanguage(newLanguage);
    translationInstance.setLanguage(newLanguage);
    
    // Force UI update by dispatching a custom event
    window.dispatchEvent(new Event('languageChanged'));
  };
  
  if (!mounted) return null; // Prevent flash of unstyled content
  
  // If multilanguage support is disabled, don't render the component
  if (!isMultilangEnabled) return null;
  
  return (
    <div className="language-selector-container">
      <div className="language-buttons">
        <button 
          className={`language-button ${selectedLanguage === 'en' ? 'active' : ''}`}
          onClick={() => handleLanguageChange('en')}
        >
          EN
        </button>
        <button 
          className={`language-button ${selectedLanguage === 'pl' ? 'active' : ''}`}
          onClick={() => handleLanguageChange('pl')}
        >
          PL
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector;
